var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TripsMarker',{attrs:{"coordinates":_vm.coordinates,"foreground":""}},[_c('IconTripsStopMarker',{attrs:{"width":"50","height":"60"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }